<style scoped>
	.windows-sized{
		height : 100vh;
	}
	#content{
		background-color:white;
	}
</style>
<template>
	<div class="fade page-sidebar-fixed page-header-fixed show page-container" id="app" v-if="!pageOptions.pageEmpty" v-bind:class="{
		'page-sidebar-minified': pageOptions.pageSidebarMinified,
		'page-content-full-height': pageOptions.pageContentFullHeight,
		'page-without-sidebar': pageOptions.pageWithoutSidebar,
		'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
		'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
		'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
		'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
		'page-with-top-menu': pageOptions.pageWithTopMenu,
		'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
		'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
		'has-scroll': pageOptions.pageBodyScrollTop
	}">
		<Header  v-if="pageOptions.pageWithHeader" />
		<TopMenu v-if="pageOptions.pageWithTopMenu" />
		<Sidebar v-if="!pageOptions.pageWithoutSidebar" />
		<SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
		<div id="content" class="content" v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }">
			<router-view></router-view>
			<vue-ins-progress-bar></vue-ins-progress-bar>
		</div>
		<Footer />
	</div>
	<div v-else>
		<router-view></router-view>
		<vue-ins-progress-bar></vue-ins-progress-bar>
	</div>
</template>

<script>

import Header from '@/components/header/Header'
import Footer from '@/components/footer/Footer'
import Sidebar from '@/components/sidebar/Sidebar'
import TopMenu from '@/components/top-menu/TopMenu'
import PageOptions from '@/Options/PageOptions.js'

export default {
  name: 'app',
  components : {
    Header,
    Footer,
    Sidebar,
    TopMenu
  },
  data(){
	  return{
		  pageOptions : PageOptions,
		  refCount : 0,
		  isLoading : false,
		  logoutStatus : false
	  }
  },
  methods : {
    setLoading(isLoading){ 
		if (isLoading) {
			this.refCount++;
			this.$swal({
				title: 'Loading.....'
			});
			this.$swal.showLoading();
			this.isLoading = true;
		} else if (this.refCount > 0) {
			this.refCount--;
			this.$swal.close();
			this.isLoading = (this.refCount > 0);
		}
	},
	logout(){

		this.$http.post('/api/auth/logout' )
			.then((resp)=>{
				if(resp.data.code != 200)
					throw new Error(resp.data.message);
				
				this.$store.dispatch('setUser', null)
				this.$http.defaults.headers.common['Authorization'] = "";
				this.logoutStatus = false;
				this.$store.dispatch('setFilterOptions' , null)
				this.$router.push({ path :'/login'})
				
				alert("Session has Expired. Please Login Again");
			})
			.catch((err)=>{
				console.log(err);
			})

		//delete token 
	}
  },
  created(){
    PageOptions.pageBodyScrollTop = window.scrollY;

		window.addEventListener('scroll', this.handleScroll);

		this.$insProgress.start()

		this.$router.beforeEach((to, from, next) => {
			this.$insProgress.start()
			next()
		})
		this.$router.afterEach(() => {
			this.$insProgress.finish()
		})

		var user = this.$store.state.userData.userData;

		this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;

		this.$http.interceptors.request.use((config) => {
			this.setLoading(true);
			return config;
		}, (error) => {
			this.setLoading(false);
			return Promise.reject(error);
		});

		this.$http.interceptors.response.use(async (response) => {
			this.setLoading(false);
			// console.log(response.data.code , 'a')
			//if response code is 200, continue request
			if(response.data.code == 200)
				return response;
			//if response has session / unauthorised problems, logout and delete remaining request
			else if(response.data.code == 11 ){
				await this.logout();
				return new Promise(() => {});
			}
			//if every other error response
			else {
				// console.log(response.data.code)
				return Promise.reject(response)
			}
				
		}, (error) => {
			this.setLoading(false);
			console.log(error)
			return Promise.reject(error);
		});
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



